import { Image, message, Tabs } from "antd";
import { Button, Col, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ModalCloseIcon } from "../../../../../constants/svg";
import { setSelectPreUploadedFile } from "../../../../../store/slices/globalSlice";
import { setUploadFileTabNo } from "../../../../../store/slices/resourcesSlice";
import GalleryTab from "../../../../Common/GalleryTab";
import FolderTab from "../../../../Common/FolderTab";
import React, { useEffect, useState } from "react";
import FileUploader from "../../../../Common/FileUploader";

const ThirdStep = ({
  register,
  watch,
  control,
  setValue,
  errors,
  getValues,
  submitted = false,
  enableCropper = false,
}) => {
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const { uploadFileTabNo } = useSelector((state) => state.resources);

  useEffect(() => {
    setImage(getValues("previewThirdStepAttachment"));
  }, [getValues("previewThirdStepAttachment"), image]);
  // Dragger image options
  const props = {
    name: "file",
    multiple: true,
    accept: ".png,.jpg,.jpeg,.gif",
    beforeUpload: (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files!");
      }
      return isImage;
    },
    showUploadList: {
      showDownloadIcon: false,
      showRemoveIcon: true,
      removeIcon: <ModalCloseIcon />,
    },
  };

  // Table Component data

  const TabsContent = [
    {
      key: 1,
      label: `Gallery`,
      children: (
        <>
          <Controller
            control={control}
            name="uploadFromGallery"
            rules={{
              required:
                uploadFileTabNo == 2 &&
                getValues("uploadFromGallery") == "" &&
                getValues("uploadFromLocal") == "" &&
                getValues("uploadFromFolder") == ""
                  ? "Please select file from gallery"
                  : false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <GalleryTab
                incSearch={true}
                handleChange={(e) => {
                  // setValue("uploadFromGallery", "");
                  setValue("previewThirdStepAttachment", "");
                  onChange(e);
                }}
                submitted={submitted}
              />
            )}
          />
          {/* {errors.uploadFromGallery && (
            <Form.Text>{errors.uploadFromGallery.message}</Form.Text>
          )} */}
        </>
      ),
    },
    {
      key: 2,
      label: `Folders`,
      children: (
        <>
          <Controller
            control={control}
            name="uploadFromFolder"
            rules={{
              required:
                uploadFileTabNo == 3 &&
                getValues("uploadFromGallery") == "" &&
                getValues("uploadFromLocal") == "" &&
                getValues("uploadFromFolder") == ""
                  ? "Please select file from folder"
                  : false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <FolderTab
                handleChange={(e) => {
                  setValue("uploadFromFolder", "");
                  setValue("previewThirdStepAttachment", "");
                  onChange(e);
                }}
                submitted={submitted}
              />
            )}
          />
          {/* {errors.uploadFromFolder && (
            <Form.Text>{errors.uploadFromFolder.message}</Form.Text>
          )} */}
        </>
      ),
    },
    {
      key: 3,
      label: `Upload`,
      children: (
        <div style={{ marginTop: "16px" }}>
          <Controller
            control={control}
            name="uploadFromLocal"
            rules={{
              required:
                uploadFileTabNo == 1 &&
                getValues("uploadFromGallery") == "" &&
                getValues("uploadFromLocal") == "" &&
                getValues("uploadFromFolder") == ""
                  ? "Please Select file from local drive"
                  : false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <FileUploader
                {...props}
                enableCropper={enableCropper}
                fileList={value == "" ? [] : [value]}
                onChange={(e) => {
                  const fileList = e.fileList;
                  onChange(
                    !fileList.length
                      ? ""
                      : fileList.length > 1
                        ? fileList[1]
                        : fileList[0],
                  );
                  // setValue("previewThirdStepAttachment", "");
                }}
                beforeUpload={() => false}
                className={`custom-upload border-0 bg-0 ${value == "" ? "hasError" : ""}`}
                listType="picture"
                limitMegabyteSize={4}
              />
            )}
          />
          {/* {errors.uploadFromLocal && (
            <Form.Text>{errors.uploadFromLocal.message}</Form.Text>
          )} */}
        </div>
      ),
    },
  ];

  const handleTabsChange = (tabNo) => {
    setValue("uploadFromLocal", "");
    setValue("uploadFromGallery", "");
    setValue("uploadFromFolder", "");
    dispatch(setSelectPreUploadedFile(""));
    dispatch(setUploadFileTabNo(tabNo));
  };

  const handleDelete = () => {
    setImage(null);
    setValue("uploadFromLocal", "");
    setValue("uploadFromGallery", "");
    setValue("uploadFromFolder", "");
    setValue("previewThirdStepAttachment", "");
  };

  return (
    <>
      <p className="proTipText mb-20">
        <span>Pro Tip:</span> Upload a cover photo or choose from the gallery.
        For best results, use an image with little or no text.
      </p>

      <Tabs
        items={TabsContent}
        onChange={handleTabsChange}
        defaultActiveKey="1"
      />

      {image && !(uploadFileTabNo === 1 && getValues("uploadFromLocal")) && (
        <Row>
          <Col md={12}>
            <div className="img-upload-preview">
              {/* <strong>Preview</strong> */}
              {/* <br /> */}
              <Image
                className="ant-img-custom-css upload-img"
                preview={false}
                src={image}
              />
              {!submitted && (
                <Button
                  type="button"
                  className={"delete-img"}
                  onClick={() => handleDelete()}
                >
                  <ModalCloseIcon />
                </Button>
              )}
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

export default ThirdStep;
